import { TranslationService } from "../../../../services/TranslationService";
import { restTimezone } from "../../../../utils/ParseUtils";
import { getDaysSince } from "../../../agenda/utils/agendaUtils";

const fill = (template: string, values: Record<string, string | number>) =>
  Object.entries(values).reduce(
    (text, [key, value]) => text.split(`{${key}}`).join(String(value)),
    template
  );

/** "Hoy", "Ayer" o "Hace N días", en la zona horaria de la empresa. */
export function formatAnnouncementDate(
  publishedAt: string,
  now: Date = new Date()
): string {
  const { translate } = TranslationService;
  const days = getDaysSince(restTimezone(new Date(publishedAt)), now);
  if (days === 0) {
    return translate.Today;
  }
  if (days === 1) {
    return translate.AnnouncementYesterday;
  }
  return fill(translate.NDaysAgo, { days });
}

/** "1 de 3" */
export function formatAnnouncementCounter(current: number, total: number) {
  return fill(TranslationService.translate.AnnouncementCounter, {
    current,
    total
  });
}
